
import { Vue, Component, Prop } from 'vue-property-decorator'
import Icon from '~/components/common/icon/Icon.vue'

@Component({
  name: 'PhotoPreview',
  components: {
    Icon
  }
})

export default class PhotoPreview extends Vue {
  @Prop() photo!: string

  private isLoading = true
}
